<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5DRush/tc-custom/9781426824449.jpg?1728326983774" alt="This image is the cover for the book Nick of Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nick of Time
      </h1>
      <p class="bookDescription body article font2">
        <p>Nick St. Claire had come to North Pole, Alaska, with a few questions for Santa, only Claus had gone AWOL. Clearly, someone was trying to ruin the holidays, though the clever cowboy never had much use for them. Until he met Mary Christmas...<br/><br/>Santa's only child, Mary, was left to tend shop in his absence--suddenly making her a killer's next target. Nick volunteered to protect her, but he was also a stranger, with a bundle of his own not-so-saintly secrets. Could Mary enlighten him on the joys of the season, or would a missing Santa squash her holiday spirit?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elle James
      </h2>
      
      <p class="authorDescription body article">Raised an Air Force brat, Elle James got her work ethic from her dad, creativity from mom and inspiration from her sister. As a member of the reserves, she's traveled, managed a career, and raised three children. She and her husband even raised ostriches and emus. Ask her what it's like to go toe-to-toe with a 350-pound bird!&#160;Former manager of computer programmers, Elle is happy to write full time in NW Arkansas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?588aa162